<template>
  <div class="meeting_info_top_box">
    <a class="menu hidden-md-and-up" @click="changeDrawer()">
      <i class="el-icon-menu"></i>
      {{ currentNavText }}
    </a>
    <div class="meeting_info_logo hidden-sm-and-down" v-if="!isCould">
      <a href="javascript:void(0)" @click="goHome()" v-if="meetingType === 0">
        <img src="../assets/images/logo.png" />
      </a>
      <a href="javascript:void(0)" @click="goHome()" v-if="meetingType === 1">
        <img src="../assets/images/logo2.png" />
      </a>
      <a href="javascript:void(0)" @click="goHome()" v-if="meetingType === 2">
        <img src="../assets/images/logo3.png" />
      </a>
    </div>
    <div class="meeting_info_goBack">
      <a href="javascript:void(0)" @click="goBackMeetingListClick()">
        <i class="iconfont icon-fanhui"></i>
        返回
      </a>
    </div>
    <div class="meeting_info_head hidden-sm-and-down">
      <div class="meeting_info_head_title" v-show="meetingName">
        <i
          class="iconfont icon-huiyi3-copy meeting_info_head_title_icon"
          v-if="meetingType === 0"
        ></i>
        <i
          class="iconfont icon-toupiaoguanli meeting_info_head_title_icon"
          v-if="meetingType === 2"
        ></i>
        <i
          class="iconfont icon-qa1 meeting_info_head_title_icon"
          v-if="meetingType === 1"
        ></i>
        <div :title="this.meetingName" style="max-width: 500px">
          <div v-html="meetingName"></div>
        </div>
        <span v-if="meetingState === 1" class="span_tip draft_bg_color">
          {{ meetingStrState }}
        </span>
        <span v-if="meetingState === 4" class="span_tip publish_bg_color">
          {{ meetingStrState }}
        </span>
        <span v-if="meetingState === 3" class="span_tip end_bg_color">
          {{ meetingStrState }}
        </span>
        <span v-if="meetingState === 6" class="span_tip close_bg_color">
          {{ meetingStrState }}
        </span>
        <el-link
          :title="'编辑' + meetingTypeText"
          :underline="false"
          @click="openMettingEdit()"
          v-if="meetingType !== 2"
        >
          <i class="el-icon-edit-outline"></i>
        </el-link>
      </div>
    </div>
    <div class="meeting_info_right">
      <el-link
        v-if="meetingState === 1 && meetingType !== 2"
        type="success"
        :underline="false"
        @click="meetingPublish()"
      >
        开始{{ meetingTypeText }}
        <i class="iconfont icon-kaiqiguanbifuwuqi"></i>
      </el-link>
      <el-link
        v-if="meetingState === 3 && meetingType !== 2"
        type="success"
        :underline="false"
        @click="meetingPublish()"
      >
        重启{{ meetingTypeText }}
        <i class="iconfont icon-kaiqiguanbifuwuqi"></i>
      </el-link>
      <el-link
        v-if="meetingState === 4 && meetingType !== 2"
        type="success"
        :underline="false"
        @click="meetingCloseRelease()"
      >
        结束{{ meetingTypeText }}
        <i class="iconfont icon-kaiqiguanbifuwuqi"></i>
      </el-link>
      <el-link
        v-if="meetingState === 3 && meetingType !== 2"
        type="info"
        :underline="false"
        @click="meetingClose()"
      >
        关闭{{ meetingTypeText }}
      </el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeetingHomeHead',
  data () {
    return {
      isCould: false
    }
  },
  props: {
    meetingId: { type: String },
    meetingName: { type: String },
    meetingState: { type: Number },
    meetingStrState: { type: String },
    meetingType: { type: Number },
    meetingTypeText: { type: String },
    fatherGetMeetingVoteInfo: {
      type: Function,
      default: null
    },
    fatherRefreshHeadMeetingList: {
      type: Function,
      default: null
    },
    fatherClickLeftNav: {
      type: Function,
      default: null
    },
    currentNavText: { type: String }
  },
  methods: {
    handleClose (done) {
      done()
    },
    goHome: function () {
      //   this.$router.push({ path: '/' })
      window.location.href = '/index.html'
    },
    goBackMeetingListClick: function () {
      this.$router.push({ name: 'meetingList' })
    },
    meetingPublish: function () {
      this.$confirm('该操作将发布' + this.meetingTypeText + '“' + this.meetingName + '”，是否继续？', '提示-发布' + this.meetingTypeText, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        this.$api.meetingManage.meetingPublish(this.meetingId)
          .then(data => {
            this.$message({
              type: 'success',
              message: this.meetingTypeText + '发布成功！',
              customClass: 'custom_message'
            })
            this.fatherGetMeetingVoteInfo()
            this.fatherRefreshHeadMeetingList()
          }).catch(err => {
            return err
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消发布' + this.meetingTypeText,
          customClass: 'custom_message'
        })
      })
    },
    meetingCloseRelease: function () {
      this.$confirm('该操作将结束' + this.meetingTypeText + '“' + this.meetingName + '”，是否继续？', '提示-结束' + this.meetingTypeText, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        this.$api.meetingManage.meetingCloseRelease(this.meetingId)
          .then(data => {
            this.$message({
              type: 'success',
              message: this.meetingTypeText + '已结束！',
              customClass: 'custom_message'
            })
            this.fatherGetMeetingVoteInfo()
            this.fatherRefreshHeadMeetingList()
          }).catch(err => {
            return err
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消结束' + this.meetingTypeText,
          customClass: 'custom_message'
        })
      })
    },
    meetingClose: function () {
      this.$confirm('该操作将关闭' + this.meetingTypeText + '“' + this.meetingName + '”，是否继续？', '提示-关闭' + this.meetingTypeText, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        this.$api.meetingManage.meetingClose(this.meetingId)
          .then(data => {
            this.$message({
              type: 'success',
              message: this.meetingTypeText + '已关闭！',
              customClass: 'custom_message'
            })
            this.fatherGetMeetingVoteInfo()
            this.fatherRefreshHeadMeetingList()
          }).catch(err => {
            return err
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消关闭' + this.meetingTypeText,
          customClass: 'custom_message'
        })
      })
    },
    openMettingEdit: function () {
      if (this.meetingType === 0) {
        this.$router.push({ name: 'meetingBasic', params: { mid: this.$route.params.mid } })
      } else if (this.meetingType === 2) {
        this.$router.push({ name: 'meetingBasic', params: { mid: this.$route.params.mid } })
      } else {
        this.$router.push({ name: 'wj_manageBasic', params: { mid: this.$route.params.mid } })
      }
    },
    changeDrawer: function () {
      this.fatherClickLeftNav()
    }
  },
  created () {
    if (this.$route.query.site) {
      if (this.$route.query.site === 'cloud') {
        this.isCould = true
      }
    }
  }
}
</script>
